import { render, staticRenderFns } from "./kafpos-form-success.vue?vue&type=template&id=19e79900&lang=pug"
import script from "./kafpos-form-success.vue?vue&type=script&setup=true&lang=js"
export * from "./kafpos-form-success.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports